import { validateForUI } from 'common/helpers/jsonValidator';

const carrierPickupLocationSchema = {
  type: 'object',
  properties: {
    carrierPickupLocationId: { type: 'string' }
  },
  required: ['carrierPickupLocationId'],
  additionalProperties: false
};

export const validateCarrierPickupLocation = (carrierPickupLocation) => {
  const errors = validateForUI(
    carrierPickupLocationSchema,
    carrierPickupLocation
  );
  return errors;
};
